<template>
  <div :id="customId" />
</template>

<script>
import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-vue-popups'

export default {
  name: 'LoadingSpinner',
  props: {
    customId: {
      type: String,
      required: false,
      default: 'loading-spinner'
    },
    loadingStatus: Boolean
  },
  watch: {
    loadingStatus (status) {
      if (status) {
        showSpinner(document.getElementById(this.customId))
      } else {
        hideSpinner(document.getElementById(this.customId))
      }
    }
  },
  mounted () {
    createSpinner({
      // Specify the target for the spinner to show
      target: document.getElementById(this.customId)
    })
    if (this.loadingStatus === true) {
      showSpinner(document.getElementById(this.customId))
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
